import { render } from "./Anime.vue?vue&type=template&id=03e71808&scoped=true"
import script from "./Anime.vue?vue&type=script&lang=js"
export * from "./Anime.vue?vue&type=script&lang=js"

import "./Anime.vue?vue&type=style&index=0&id=03e71808&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-03e71808"

export default script